export const FEATURECONSTANTS = [
	{
	  imageUrl: "../src/assets/20230520_181045.jpg",
	  cardTitle: "Limitless Test Questions Powered by AI",
	  caption:
		"Generate on-demand questions for any exam topic at the click of a button. Focus practice where you need it most—without scouring practice books or online resources.",
	},
	{
	  imageUrl: "../src/assets/20221124_164829.jpg",
	  cardTitle: "Personalized Feedback for You",
	  caption:
		"Pinpoint your toughest areas with targeted questions and tailored recommendations. Get the insights you need to boost your scores more effectively.",
	},
	{
	  imageUrl: "../src/assets/ErasedBG2.jpg",
	  cardTitle: "Your All-in-One Workspace",
	  caption:
		"Say goodbye to juggling multiple apps. Access AI-generated practice, track your progress, and collaborate (if needed) within a single, streamlined platform.",
	},
	{
	  imageUrl: "../src/assets/ErasedBG2.jpg",
	  cardTitle: "Track Your Progress Over Time",
	  caption:
		"Monitor how your skills improve with detailed metrics. Identify weak spots quickly and stay on top of your performance with easy-to-understand progress reports.",
	},
	{
	  imageUrl: "../src/assets/ErasedBG3.png",
	  cardTitle: "Dive Deeper with Advanced Analytics",
	  caption:
		"Break down your performance by topic, question type, or time period. Spot trends and make data-driven decisions about where to focus your efforts.",
	},
	{
	  imageUrl: "../src/assets/BlackCloverBG1.png",
	  cardTitle: "Manage Billing or Subscription in One Place",
	  caption:
		"No more hassle with separate payment systems. Handle any billing or subscription details within the platform quickly and securely.",
	},
	{
	  imageUrl: "../src/assets/20230530_111147.jpg",
	  cardTitle: "Automated Assignment Tracking",
	  caption:
		"Easily set up due dates for quizzes or tasks. Receive automated reminders so you never miss an assignment—stay accountable without lifting a finger.",
	},
	{
	  imageUrl: "../src/assets/20230530_111147.jpg",
	  cardTitle: "Automate Reminders for Progress Updates",
	  caption:
		"Get timely email notifications about your recent progress, completed tasks, and upcoming goals. Let the system keep you informed automatically.",
	},
	{
	  imageUrl: "../src/assets/20230530_111147.jpg",
	  cardTitle: "Real-Time Grading for Tests & Quizzes",
	  caption:
		"Stop spending time on manual scoring. Get instant results and personalized insights as soon as you complete each test or quiz.",
	},
  ];
  